var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91365 7.39852C2.94062 7.3215 3.01639 7.26953 3.10175 7.26953H16.4209C16.5078 7.26953 16.5846 7.32342 16.6103 7.40243L19.0614 14.9488C19.1008 15.0701 19.0055 15.193 18.872 15.193H0.460119C0.324832 15.193 0.229286 15.0669 0.272022 14.9449L2.91365 7.39852ZM10.7754 8.34766H8.55671L8.30678 10.2323H11.0194L10.7754 8.34766ZM8.06284 12.117L7.80632 14.0016H11.5194L11.2693 12.117H8.06284ZM3.51501 8.34397H6.56313L6.31127 10.2344H2.9907L3.51501 8.34397ZM6.11214 12.1032H2.51637L1.99244 13.9926H5.81522L6.11214 12.1032ZM15.8109 8.34397H12.7628L13.0147 10.2344H16.3352L15.8109 8.34397ZM13.2138 12.1032H16.8095L17.3335 13.9926H13.5107L13.2138 12.1032Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0974 0.0234375C13.0974 1.88856 11.5077 3.40053 9.54676 3.40053C7.58578 3.40053 5.99609 1.88856 5.99609 0.0234375C8.23637 0.0236677 7.58578 0.0241152 9.54676 0.0241152C11.5077 0.0241152 10.5626 0.0234375 13.0974 0.0234375Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82757 4.72135C3.7308 4.6293 3.7308 4.48007 3.82757 4.38803L5.49864 2.79865C5.59542 2.70661 5.75232 2.70661 5.8491 2.79865C5.94587 2.8907 5.94587 3.03993 5.8491 3.13198L4.17803 4.72135C4.08125 4.81339 3.92435 4.81339 3.82757 4.72135Z",
    fill: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0201 2.79947C13.1169 2.70743 13.2738 2.70743 13.3705 2.79947L15.0416 4.38885C15.1384 4.48089 15.1384 4.63013 15.0416 4.72217C14.9448 4.81422 14.7879 4.81422 14.6912 4.72217L13.0201 3.1328C12.9233 3.04075 12.9233 2.89152 13.0201 2.79947Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0625 0.290384C14.0625 0.160212 14.1734 0.0546875 14.3103 0.0546875L16.6736 0.0546875C16.8104 0.0546875 16.9214 0.160212 16.9214 0.290384C16.9214 0.420555 16.8104 0.52608 16.6736 0.52608H14.3103C14.1734 0.52608 14.0625 0.420555 14.0625 0.290384Z",
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22656 0.290384C2.22656 0.160212 2.33751 0.0546875 2.47437 0.0546875L4.83762 0.0546875C4.97448 0.0546875 5.08543 0.160212 5.08543 0.290384C5.08543 0.420555 4.97448 0.52608 4.83762 0.52608H2.47437C2.33751 0.52608 2.22656 0.420555 2.22656 0.290384Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4475 3.78906C9.58436 3.78906 9.69531 3.89459 9.69531 4.02476V6.27247C9.69531 6.40265 9.58436 6.50817 9.4475 6.50817C9.31064 6.50817 9.19969 6.40265 9.19969 6.27247V4.02476C9.19969 3.89459 9.31064 3.78906 9.4475 3.78906Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarIcon);
export default __webpack_public_path__ + "static/media/solar_icon.2ca3e77945e00e8bde76986579bd709b.svg";
export { ForwardRef as ReactComponent };